import React from "react";
import { getResponsiveImage } from "../../utils/imageHelper";


/*eslint-disable */

declare const window: any;

interface FinanzasOportunidadesComponentProps {
  opportunities: any;
}

const FinanzasOportunidadesComponent: React.FC<
  FinanzasOportunidadesComponentProps
> = ({ opportunities }) => {

  const [isVisible, setIsVisible] = React.useState(false);
  const ref = React.useRef<HTMLDivElement | null>(null);
  
  React.useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else if (entry.boundingClientRect.top > 0) {
          setIsVisible(false);
        }
      },
      {
        threshold: 0.1,
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return (
    <div ref={ref} className={`otros-finance-detail-component ${isVisible ? "visible" : ""}`}>
      {/* H2 - Título de la sección */}
      <h2 className="title-otros-finance-detail-component">
        Más oportunidades
      </h2>
      
      <div className="opciones-otros-finance-detail-component">
        {opportunities?.map((item: any, index: number) => (
          <div
            key={index}
            className={`item-opciones-otros-finance-detail-component`}
            style={{
              backgroundImage:
                `URL(${getResponsiveImage(item?.image?.url || item?.media?.url || '').desktop})`,
            }}

          >
            <div
              className={`mascara-item-opciones-otros-finance-detail-component`}
            >
              {/* H3 - Título de la oportunidad */}
              <h3 className="title-mascara-item-opciones-otros-finance-detail-component">
                {item?.title}
              </h3>
              
              {/* BOTÓN SIN MODIFICAR */}
              <a
                href={item?.url}
                className="btn-page-other-page-home-component"
              >
                {item?.button_text || item?.title}
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FinanzasOportunidadesComponent;